import { EntityKeyByReference, FilterOption, Note } from '@card-software/library';
import { AuditTrail } from '@card-software/nexus-models';
import { Business } from '../finance/business';

export interface Requisition extends AuditTrail {
  id?: string;
  type: number; //RequisitionType
  requisitionNumber?: string;
  initiatorNumber?: string;
  initiator: EntityKeyByReference;
  requisitionEntries: RequisitionEntry[];
  status: number;
  requester: EntityKeyByReference;
  plannedIssuer: EntityKeyByReference;
  notes?: Note[];
}

export interface RequisitionEntry {
  itemCode: string;
  materialForItemCode: string;
  providerReference: string;
  providerLotNumber: string;
  unitOfMeasure: number;
  requiredQuantityInUnitOfMeasure: number;
  manufacturer?: Business;
  // Links this line back to the specific Knitting Order Entry (FabricQuantityDetail.variantCode) it was requisitioned for.
  // Needed because two Entries of the same Knitting Order can share the same itemCode+provider+lot (e.g. a common base yarn),
  // which makes that combination alone ambiguous for matching entries back to their Entry.
  knittingOrderEntryVariantCode?: string;
}

export enum RequisitionStatus {
  Requested,
  Processing,
  InRoute,
  Received,
  Rejected,
  Voided,
}

export interface RequisitionSearchCommand {
  requisitionNumber?: string;
  initiator?: EntityKeyByReference;
  statuses?: number[];
  types?: number[];
}

export interface RequisitionFilters {
  requisitionNumber?: string;
  knittingOrder?: string | { id?: string };
  statuses?: (number | FilterOption)[];
  requisitionTypes?: (number | FilterOption)[];
}
